export default __webpack_public_path__ + "static/media/scdream7.a6ddd857.woff";